"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

var _initializeApp = require("@insided/destination/app/initializeApp");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'oembed';
exports.cssAnchorName = cssAnchorName;

var OEmbed = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(OEmbed, _Component);

  var _super = _createSuper(OEmbed);

  function OEmbed() {
    var _this;

    (0, _classCallCheck2.default)(this, OEmbed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      embedCode: '',
      hasError: false,
      hasAccess: false
    });
    return _this;
  }

  (0, _createClass2.default)(OEmbed, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _axios.default.get('/oembed/getembeddedUrl?url=' + encodeURIComponent(this.props.url)).then(function (res) {
        _this2.setState({
          embedCode: res.data.html.replace('http://', 'https://'),
          hasAccess: true
        });
      }).catch(function (error) {
        if (error.response && error.response.status === 403) {
          _this2.setState({
            hasError: true
          });
        } else {
          _this2.setState({
            hasError: true,
            hasAccess: true
          });
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.ref) {
        (0, _initializeApp.instantiatePreactComponents)(this.ref);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var state = this.state;
      var isEmbedTopicCard;

      try {
        var embedUrl = new URL(props.url);
        isEmbedTopicCard = embedUrl.host === new URL((0, _globals.default)('communityUrl')).host;
      } catch (_unused) {
        isEmbedTopicCard = false;
      }

      if (!state.hasAccess) {
        return (0, _preact.h)("a", {
          target: "_blank",
          href: (0, _absoluteUrlRuntime.resolveUrl)(props.url),
          rel: "noreferrer nofollow noopener",
          style: {
            display: "".concat(isEmbedTopicCard ? 'block' : 'inline')
          }
        }, props.url);
      }

      if (state.hasError && isEmbedTopicCard) {
        return (0, _preact.h)("a", {
          target: "_blank",
          href: (0, _absoluteUrlRuntime.resolveUrl)(props.url),
          rel: "noreferrer nofollow noopener",
          style: {
            display: 'block'
          }
        }, props.url);
      }

      if (state.hasError) {
        return (0, _preact.h)("div", {
          className: "oembed-wrapper"
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)('box', 'box__pad', 'box--note')
        }, (0, _preact.h)(_phrase.default, {
          p: "embeddable.not.available"
        })));
      }

      return (0, _preact.h)("div", {
        className: "oembed-wrapper"
      }, (0, _preact.h)("div", {
        ref: function ref(el) {
          _this3.ref = el;
        },
        className: (0, _classnames.default)({
          'oembed-iframe-wrapper': state.embedCode.includes('<iframe')
        }),
        dangerouslySetInnerHTML: {
          __html: state.embedCode
        }
      }));
    }
  }]);
  return OEmbed;
}(_preact.Component);

var _default = OEmbed;
exports.default = _default;